import { IFeature } from 'mod/featureV2/interface';
import { overlayBanner as pcOverlayBanner } from '../pc/overlayBanner'
import { IFeatureOverlayBanner } from 'mod/featureV2/interface/overlayBanner';

export const overlayBanner: IFeature = {
    type: 'overlayBanner',
    ...(pcOverlayBanner as IFeatureOverlayBanner),
    config: {
        ...(pcOverlayBanner as IFeatureOverlayBanner).config,
        column: 1,
    }
};